export const BRAND_NAME = 'Reya5';
// Note: It is the main site url. Ex - mazaa.io, etc.
export const BRAND_DOMAIN = 'reya5.vip';
// Note: It is the main site url. Ex - mazaa.io, etc.
export const BRAND_DOMAIN_SKIN_URL = 'reya5.vip';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'mjmoon.art';
